import React from 'react';
import Page from '../components/Success/Page';

const Success = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Success;


/** WEBPACK FOOTER **
 ** ./src/containers/Success.js
 **/